import { Phone, CheckCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import '../ServicePage.css';

const PaediatricService = () => {
  const whatsappUrl = 'https://wa.me/919886332528';
  const conditions = ['Cerebral palsy', 'Developmental delays', 'Muscular dystrophy', 'Down syndrome', 'Autism spectrum (movement issues)', 'Brachial plexus injuries', 'Torticollis', 'Gait abnormalities'];
  const equipment = ['Pediatric exercise equipment', 'Balance and coordination tools', 'Play-based therapy tools', 'Soft tissue mobilization', 'Age-appropriate exercises'];

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Paediatric Physiotherapy</h1>
          <p className="service-subtitle">Gentle, effective treatment for children</p>
        </div>
      </div>

      <section className="section">
        <div className="container service-container">
          <div className="service-content">
            <h2>What is Paediatric Physiotherapy?</h2>
            <p>Paediatric physiotherapy specializes in assessing and treating infants, children, and adolescents with developmental, neurological, or musculoskeletal conditions. Our gentle, play-based approach helps children reach their full physical potential.</p>

            <h2>Conditions We Treat</h2>
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <li key={index}><CheckCircle size={20} /><span>{condition}</span></li>
              ))}
            </ul>

            <h2>What to Expect at Our Clinic</h2>
            <p>We create a friendly, comfortable environment for children. Assessment includes developmental milestone evaluation, movement analysis, and functional testing. Treatment uses play-based activities to engage children while achieving therapeutic goals.</p>

            <h2>Equipment Used</h2>
            <div className="equipment-tags">
              {equipment.map((item, index) => (<span key={index} className="equipment-tag">{item}</span>))}
            </div>

            <div className="service-cta">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <Phone size={20} />Book Appointment on WhatsApp
              </a>
            </div>

            <h2>Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="service-faq">
              <AccordionItem value="item-1">
                <AccordionTrigger>At what age can physiotherapy start for children?</AccordionTrigger>
                <AccordionContent>Physiotherapy can begin at any age, even in early infancy. Early intervention is often crucial for best outcomes, especially for developmental conditions.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Will my child be afraid or uncomfortable?</AccordionTrigger>
                <AccordionContent>We use play-based, child-friendly approaches to make therapy fun and engaging. Most children enjoy their sessions once they become comfortable with the therapist.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>Can parents stay during the session?</AccordionTrigger>
                <AccordionContent>Yes, parent involvement is encouraged! We teach you exercises and activities to continue at home, which is essential for your child's progress.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>Do you provide home visits for children?</AccordionTrigger>
                <AccordionContent>Yes, we offer home visits for paediatric patients, which can be more comfortable for both children and parents, especially for very young children or those with severe conditions.</AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PaediatricService;